import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var LinksList = /*#__PURE__*/ styled("ul", {
    target: "ea2y1440"
})("margin-bottom:1rem;display:grid;column-gap:1rem;grid-template-columns:1;", Theme.mq("sm"), "{grid-template-columns:repeat(3,1fr);}");
var LinkItem = /*#__PURE__*/ styled("li", {
    target: "ea2y1441"
})("display:flex;align-items:center;gap:0.625rem;margin-bottom:0.3125rem;");
export { LinksList, LinkItem };
